/**
 * Single source of truth for app colors (replaces legacy `src/colors.js`).
 * MUI app theme uses `brandColors` / `semanticColors` via `theme/index.js`.
 */

export const brandColors = {
    blue: '#005596',
    red: '#bd131e',
    yellow: '#edb528',
    green: '#348a79',
};

export const semanticColors = {
    appBackground: '#FAFAFA',
    surface: '#FFFFFF',
    textPrimary: '#414142',
    surfaceMuted: '#F1F1F2',
    borderSubtle: '#F1F1F2',
    borderSubtleStrong: '#D9D9DD',

    // Backward-compatible aliases (to be phased out gradually)
    detailsCardBorder: '#F1F1F2',
    detailsCardBackground: '#FAFAFA',
    detailsCardBorderStrong: '#D9D9DD',
};

/** Semantic status / feedback (from legacy `colors.js` status). */
export const statusColors = {
    success: '#33b361',
    info: '#0052cc',
    warning: '#f2b313',
    danger: '#e53e3e',
    charging: '#0000FF',
};

/** Charge points status-toast backgrounds (requested design values). */
export const chargePointToastColors = {
    disconnected: '#db866f',
    activeTransactionRestricted: '#f8d794',
};

/**
 * Neutral / chrome palette (from legacy `colors.js` palette.neutral).
 * `main` aligns with app primary blue.
 */
export const neutralColors = {
    main: brandColors.blue,
    secondary: '#388e7a',
    black: '#080e14',
    grey: '#e1e1e1',
    white: '#f5f5f0',
    white2: '#fafafa',
    yellow: '#f1b72b',
    red: '#bc131d',
};

/**
 * Legacy shape: `colorTheme.palette.neutral.*` / `colorTheme.status.*`
 * (drop-in for former `import colorTheme from '.../colors'`).
 */
const colorTheme = {
    status: statusColors,
    palette: {
        neutral: neutralColors,
    },
};

export default colorTheme;
